import * as Schema from "effect/Schema";
/**
 * One iManage item. `id`, `name`, `kind` and `version` are always present; the
 * rest is profile metadata the provider may or may not supply (it differs by
 * tenant and by item type), so every extra field is optional.
 */
export const IManageEntry = Schema.Struct({
  id: Schema.String,
  name: Schema.String,
  kind: Schema.Literals(["library", "matter", "folder", "document"]),
  version: Schema.NullOr(Schema.Number),
  extension: Schema.optional(Schema.String),
  /** Document number shared by every version of one document. */
  documentNumber: Schema.optional(Schema.Number),
  /** Author's display name (falls back to the author ID). */
  author: Schema.optional(Schema.String),
  /** ISO 8601 last edit time. */
  modified: Schema.optional(Schema.String),
  /** ISO 8601 creation time. */
  created: Schema.optional(Schema.String),
  /** Size in bytes. */
  size: Schema.optional(Schema.Number),
  /** True for filed emails (iManage stores them as documents). */
  email: Schema.optional(Schema.Boolean),
  emailFrom: Schema.optional(Schema.String),
  emailTo: Schema.optional(Schema.String),
  /** ISO 8601 time an email was sent. */
  sentAt: Schema.optional(Schema.String),
  /** Workspace client and matter numbers (custom1 / custom2) and their names. */
  client: Schema.optional(Schema.String),
  clientName: Schema.optional(Schema.String),
  matter: Schema.optional(Schema.String),
  matterName: Schema.optional(Schema.String),
  description: Schema.optional(Schema.String),
  owner: Schema.optional(Schema.String),
  /** Containing folder of a folder; containing workspace of a folder or document. */
  parentId: Schema.optional(Schema.String),
  workspaceId: Schema.optional(Schema.String),
});
export type IManageEntry = typeof IManageEntry.Type;
export const IManagePage = Schema.Struct({
  entries: Schema.Array(IManageEntry),
  nextOffset: Schema.NullOr(Schema.Number),
});
export type IManagePage = typeof IManagePage.Type;
export const IManageDocument = Schema.Struct({
  ...IManageEntry.fields,
  revision: Schema.NullOr(Schema.String),
  content: Schema.String,
});
export type IManageDocument = typeof IManageDocument.Type;
export const IManageStatus = Schema.Struct({
  configured: Schema.Boolean,
  connected: Schema.Boolean,
  pending: Schema.Boolean,
  canUpload: Schema.Boolean,
  canSaveVersion: Schema.Boolean,
  callbackUri: Schema.NullOr(Schema.String),
  operations: Schema.Array(Schema.String),
  saves: Schema.Array(
    Schema.Struct({
      id: Schema.String,
      status: Schema.Literals(["prepared", "saving", "saved", "failed", "uncertain"]),
      receipt: Schema.optional(IManageEntry),
      /** Library the save targeted, and the document it was reviewed from. */
      libraryId: Schema.optional(Schema.String),
      sourceId: Schema.optional(Schema.String),
      /** Epoch milliseconds the save was confirmed by iManage. */
      savedAt: Schema.optional(Schema.Number),
    }),
  ),
});
export type IManageStatus = typeof IManageStatus.Type;
